import { AppAction, PageFilter } from '../../../../state/app';

export const FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST =
  'FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST';
export const CLEAR_PENDING_APPROVAL_ASSIGNMENT_LIST =
  'CLEAR_PENDING_APPROVAL_ASSIGNMENT_LIST';

export const fetchPendingApprovalAssignmentList = (paging: PageFilter): AppAction => {
  return {
    type: FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST,
    payload: {
      filters: { 'HasResponded.EqualsTo': 'false' },
      paging,
    },
  };
};

export const clearPendingApprovalAssignmentList = () => ({
  type: CLEAR_PENDING_APPROVAL_ASSIGNMENT_LIST,
});
